import CustomCard from '../../../../src/components/card/CustomCard';
import DynamicContents from "./DynamicContents";
import React from "react";
import CustomCardHeader from "../../../components/card/CustomCardHeader";
import CardBody from "../../../components/card/CardBody";
import PageTabs from "./PageTabs";

const MobileUiView = () => {

  return (
    <CustomCard>
      {/*<div className="flex flex-wrap justify-center flex-col items-center">*/}

      {/*<div className="ui-width mt-4 bg-rand-500">*/}
      {/*<UIHeader/>*/}
      <CustomCardHeader contentPosition="none">
        <div className="w-full flex items-center justify-between">
          <h2 className="text-white text-2xl">Dynamic Ui</h2>
        </div>
      </CustomCardHeader>
      <PageTabs/>
      <CardBody className="p-0">

        <DynamicContents/>
      </CardBody>
      {/*</div>*/}

      {/*</div>*/}


    </CustomCard>
  );
};

export default React.memo(MobileUiView);
